import React, {forwardRef, useImperativeHandle, useRef, useState} from "react";
import {IconClose} from "../../Icon";
import {Button, message, Modal} from "antd";
import {t} from "i18next";
import {isValidUrl} from "../../../@excalidraw/packages/excalidraw/data/url";
import {downloadImage} from "@/utils";
import DialogProgress from "@/views/Draw/DialogProgress";
import {MAX_Z_INDEX} from "@/Const";

const DialogImageUrl = forwardRef((props:{onOkEvent:any}, ref) => {
    useImperativeHandle(ref,()=>({
        onShowDialog:onShowDialog
    }))

    const [isShowDialog,setIsShowDialog] = useState(false);
    const [inputUrl,setInputUrl] = useState('');
    const dialogProgressRef = useRef(null);
    const inputRef = useRef(null);

    const onShowDialog = ()=>{
        setIsShowDialog(true);
        setInputUrl('');
        setTimeout(()=>{
            inputRef.current?.select();
            inputRef.current?.focus();
        },50);
    }


    return(
        <Modal width={468} zIndex={MAX_Z_INDEX} bodyStyle={{height:'195px',margin:'-20px -24px -32px -24px',padding:'20px'}} open={isShowDialog} centered={true} closeIcon={<IconClose/>} footer={''} onCancel={()=>setIsShowDialog(false)}>
            <div>
                <span className={'dialog-title'}>{t("Image url")}</span>
                <div className={'line mt-12'} style={{margin:'12px -22px'}}></div>
                <input ref={inputRef} value={inputUrl} style={{marginTop:'12px',width:'100%',paddingLeft:'8px'}} onChange={(e)=>{
                    setInputUrl(e.currentTarget.value)
                }} className={'input-border'}/>
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginTop: '26px',
                    marginBottom: '-16px'
                }}>
                    {
                        <Button
                            style={{height: '34px'}}
                            className='large-w-button button-border-gray-style button-min-width font-size-14 font-family-medium'
                            onClick={() => {
                                setIsShowDialog(false);
                            }}>{t("Cancel")}</Button>
                    }
                    <Button
                        disabled={!isValidUrl(inputUrl)}
                        className='large-w-button button-solid-style button-min-width font-size-14 font-family-medium'
                        type="primary"
                        onClick={async () => {
                            //download this image....
                            dialogProgressRef.current?.onShowDialog('Loading');
                            try {
                                const szBase64 = await downloadImage(inputUrl);
                                setIsShowDialog(false);
                                props.onOkEvent(szBase64);
                            }catch (e) {
                                message.error(t("Download fail"))
                            }finally {
                                dialogProgressRef.current?.onCloseDialog();
                            }

                        }}
                        style={{
                            marginLeft: '26px',
                        }}
                        htmlType={"submit"}>{t("Ok")}</Button>
                </div>
            </div>

            <DialogProgress ref={dialogProgressRef}/>
        </Modal>
    )
})

export default DialogImageUrl;